export default {
  open: "Open",
  closed: "Closed",
  opensAt: "Opens at",
  closesAt: "Closes at",
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  mainDish: "Main Dish",
  specialDish: "Vegetarian",
  salad: "Salad",
  dessert: "Dessert",
  kyrios: "Main dish:",
  xortofagiko: "Vegetarian:",
  salata: "Salad:",
  gevma: "Lunch",
  deipno: "Dinner",
  menou: "Menu:",
  avriano: "Tomorrow's",
  simerino: "Today's",
  orario: "Schedule",
  proino: "Breakfast:",
  mesimeriano: "Lunch:",
  weekdays: "Weekdays",
  weekendsAndHolidays: "Weekends and national holidays",
  vradino: "Dinner:",
  olesOiMeres: "Days",
  monday: "MONDAY",
  tuesday: "TUESDAY",
  wednesday: "WEDNESDAY",
  thursday: "THURSDAY",
  friday: "FRIDAY",
  saturday: "SATURDAY",
  sunday: "SUNDAY",
  choiceOfSeasonalFruits: "Selection of seasonal fruits",
  choiceOfSeasonalSalads: "Selection of seasonal salads",
  gratedCheese: "Grated cheese",
  rizoto: "Risotto",
  vegetarian: "Vegetarian (for medical reasons)",
  porkBitesWithPeppersAndMushrooms: "Pork bites with peppers and mushrooms",
  porkSteakWithMustard: "Pork steak with mustard",
  xoirinoKokkinisto: "Pork cooked in tomato sauce with celery",
  xoirinoSouvlaki: "Souvlaki made of pork",
  kototiganiaAlaKrem: "Pan cooked chicken à la crème",
  mpiftekiLahanikon: "Veggie burger (patty)",
  fasoliaLadera: "Green beans with olive oil",
  mpriam: "Briam",
  lahanorizo: "Rice with cabbage",
  kotompoukiesAlaKrem: "Chicken bites à la crème",
  mpoutiKotLemonato: "Chicken thigh roasted with lemon",
  moshariNouaMeNtomata: "Mock tendered beef with fresh tomatoes",
  mpiftekiKotMeMoustarda: "Chicken burger with mustard sauce",
  roloGalopoulas: "Turkey roll",
  gemistaLadera: "Stuffed peppers with olive oil",
  kritharakiIrizi: "Barley or rice",
  cheesepie: "Tiropita (Cheese-pie)",
  spinachpie: "Spanakopita (Spinach-pie)",
  mushroompieWithFyllo: "Mushroom-pie with phyllo",
  scrambledEggs: "Scrambled eggs with tomatoes or feta cheese",
  fetaCheese: "Feta cheese",
  fakes: "Lentil soup with carrots and tomatoes",
  fasolada: "Bean soup with sausages",
  revithada: "Chickpea soup with lemons",
  fakorizo: "Rice with lentils, tomatoes and fresh onions",
  kolokithokeftedes: "Pumpkin meatballs",
  gliko: "Dessert",
  makaroniaKarbonara: "Penne pasta with cream and bacon",
  makaroniaMeSaltsa: "Penne pasta with Bolognese sauce",
  makaroniaTrikolore: "Tricolore pasta with vegetable sauce and chicken",
  makaronosalata: "Pasta based salad",
  pastitsio: "Pastitsio",
  mpiftekiBeefMeKaseri: "Beef burger with cheese",
  soutzoukakiaNtomata: "Smyrna meatballs with tomatoe sauce",
  keftedakiaKotopoulo: "Chicken meatballs with basil and tomatoes",
  xoirinoEksohiko: "Pork with feta cheese and mushrooms",
  frenchFriesAndRice: "French fries with rice",
  arakas: "Peas with potatoes and carrots",
  patatesGiahni: "Yahni potatoes",
  spanakorizo: "Spanakorizo (spinach with rice)",
  gigantes: "Gigantes plaki with peppers and basil",
  galeos: "Baked school shark slices with mustard sauce",
  soupies: "Cuttlefish chasseur with tricolore pasta",
  kritharotoThalassinon: "Orzo with seafood",
  riziKaiPatatesFournou: "Rice and potatoe bake",
  pitsaSpecial: "Pizza special with ham",
  smokedTurkey: "Bacon and steamed turkey",
  pitsaMesogeiaki: "Mediterranean pizza with gouda cheese",
  tiriKaiLahanika: "Feta cheese and vegetables",
  pitsaMeKima: "Pizza with minced meat and gouda cheese",
  pitsaMeKotopoulo: "Pizza Πίτσα με κοτόπουλο & γκούντα",
  tiganiaKotLemonati: "Pan cooked chicken with lemon",
  mpoutiKotPsito: "Roasted chicken thigh",
  xoirinoPrasoselino: "Pork with leek and celery",
  soutzoukakiaNtomataKimino: "Smyrna meatballs with tomatoe sauce and cumin",
  falafel: "Falafel",
  pouresKaiKouskous: "Mushed potatoes or couscous",
  kotosoupaAvgolemono: "Chicken soup with avgolemono",
  soufleZimTyria: "Pasta soufflé with a cheese mix",
  xoiriniPansetaSxaras: "Grilled pork pancetta",
  mprizolesXoirLemonates: "Pork steaks with lemon",
  soublakiXoirTzatzFeta: "Pork souvlaki with tzatziki and feta cheese",
  filetoMpoutiKotSxaras: "Grilled fillet chicken thigh",
  riziIpatatesTiganites: "Rice or French fries",
  loukanikoXor: "Domestic sausage",
  loukanikoVrasto: "Boiled sausage",
  omeletaZamponFeta: "Omelette with ham and feta cheese",
  patatesFournou: "Potatoe bake",
};
